const fieldLabels = [
  [/^(?:收件人|姓名|name|recipient)\s*[:：=]\s*(.+)$/i, 'reName'],
  [/^(?:收件公司|公司|company)\s*[:：=]\s*(.+)$/i, 'reCompany'],
  [/^(?:收件电话|电话|手机|phone|tel)\s*[:：=]\s*(.+)$/i, 'reTel'],
  [/^(?:收件邮箱|邮箱|email|e-mail)\s*[:：=]\s*(.+)$/i, 'reEmail'],
  [/^(?:目的地|国家|country)\s*[:：=]\s*(.+)$/i, 'reCountryCode'],
  [/^(?:收件邮编|邮编|zip|postcode|postal code)\s*[:：=]\s*(.+)$/i, 'reZip'],
  [/^(?:收件州省|州省|州|省|state|province)\s*[:：=]\s*(.+)$/i, 'reState'],
  [/^(?:收件城市|城市|city)\s*[:：=]\s*(.+)$/i, 'reCity'],
  [/^(?:收件地址2|地址2|address 2|address2)\s*[:：=]\s*(.+)$/i, 'reAddr2'],
  [/^(?:收件地址|地址|address|address 1|address1)\s*[:：=]\s*(.+)$/i, 'reAddr']
]

export const normalizeRecipientCity = city => String(city || '').trim().replace(/^New York City$/i, 'New York')

const recipientLabelNames = '收件人|姓名|name|recipient|收件公司|公司|company|收件电话|电话|手机|phone|tel|收件邮箱|邮箱|email|e-mail|目的地|国家|country|收件邮编|邮编|zip|postcode|postal code|收件州省|州省|州|省|state|province|收件城市|城市|city|收件地址2|地址2|address 2|address2|收件地址|地址|address|address 1|address1'

export function parseRecipientText (text) {
  const fields = {}
  const unlabeled = []
  const segments = String(text || '')
    .replace(new RegExp(`\\s*[,，;；]\\s*(?=(?:${recipientLabelNames})\\s*[:：=])`, 'gi'), '\n')
    .split(/(?:[\r\n]+|[ \t]{2,})/)
    .map(line => line.trim())
    .filter(Boolean)
  segments.forEach(line => {
    const match = fieldLabels.map(([pattern, field]) => ({ match: line.match(pattern), field })).find(item => item.match)
    // Address 2 is entered manually. Consume its label without assigning it to any other field.
    if (match) {
      if (match.field !== 'reAddr2') fields[match.field] = match.match[1].trim()
    } else unlabeled.push(...line.split(/[,，;；]+/).map(part => part.trim()).filter(Boolean))
  })

  const remaining = []
  unlabeled.forEach(line => {
    const cityStateZip = line.match(/^(.+?)[,\s]+([A-Z]{2})\s+(\d{5})(?:-\d{4})?$/i)
    const stateZip = line.match(/^([A-Z]{2})\s+(\d{5})(?:-\d{4})?$/i)
    if (cityStateZip) {
      if (!fields.reCity) fields.reCity = cityStateZip[1].trim()
      if (!fields.reState) fields.reState = cityStateZip[2].toUpperCase()
      if (!fields.reZip) fields.reZip = cityStateZip[3]
    } else if (stateZip) {
      if (!fields.reCity && remaining.length >= 3 && !/^\d|^P\.?O\.?\s*Box/i.test(remaining[remaining.length - 1])) fields.reCity = remaining.pop()
      if (!fields.reState) fields.reState = stateZip[1].toUpperCase()
      if (!fields.reZip) fields.reZip = stateZip[2]
    } else if (/^[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(line)) {
      if (!fields.reEmail) fields.reEmail = line
    } else if (/^\+?[\d(][\d\s().-]{6,}$/.test(line)) {
      if (!fields.reTel) fields.reTel = line
    } else if (/^\d{5}(?:-\d{4})?$/.test(line)) {
      if (!fields.reZip) fields.reZip = line
    } else if (/^(?:US|USA|United States(?: of America)?|美国)$/i.test(line)) {
      if (!fields.reCountryCode) fields.reCountryCode = line
    } else {
      remaining.push(line)
    }
  })

  if (!fields.reName && remaining.length && !/^\d|^P\.?O\.?\s*Box/i.test(remaining[0])) fields.reName = remaining.shift()
  if (!fields.reCompany && remaining.length > 1 && !/^\d|^P\.?O\.?\s*Box/i.test(remaining[0])) fields.reCompany = remaining.shift()
  if (!fields.reAddr && remaining.length) fields.reAddr = remaining.shift()
  if (!fields.reCountryCode && /^\d{5}(?:-\d{4})?$/.test(fields.reZip || '') && /^[A-Z]{2}$/.test(fields.reState || '')) fields.reCountryCode = 'US'
  if (fields.reCity) fields.reCity = normalizeRecipientCity(fields.reCity)
  return fields
}

export function convertUnitValue (value, factor) {
  if (value === '' || value == null) return value
  const number = Number(value)
  if (!Number.isFinite(number)) return value
  return Number((number * factor).toFixed(3))
}

export function apiMeasurementValue (value, factor, decimals) {
  if (value === '' || value == null) return null
  const number = Number(value)
  return Number.isFinite(number) ? Number((number * factor).toFixed(decimals)) : null
}
